/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Report_Tab_DeliveryInputs */

const vi_report_tab_delivery = /** @type {(inputs: Report_Tab_DeliveryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giao hàng`)
};

/**

* @param {Report_Tab_DeliveryInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const report_tab_delivery = /** @type {((inputs?: Report_Tab_DeliveryInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Report_Tab_DeliveryInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_report_tab_delivery(inputs)
});